import { Helmet } from "react-helmet";
import {
  Avatar,
  Box,
  ClickAwayListener,
  Stack,
  MenuItem,
  MenuList,
  Divider,
  InputAdornment,
  TextField,
  Select,
  Container,
  Grid,
  Typography,
  Button,
  usePagination,
  Grow,
  Popper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import * as Util from "../../../../services/global.service";

import Search from "@mui/icons-material/Search";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";

import ResultDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/MessageDialog";
import CreateDialog from "../../../../components/adminConfigWorkflow/CreateDialog";
import CustomPagination from "../../../../components/CustomPagination";

import { getCalibrationList } from "../../../../actions/calibration"

const useStyles = makeStyles({
  wrapperContent: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap"
  },
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    },
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        ",
  },
})
const styles = {
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
}

const Calibration = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const language = localStorage.getItem("lang");

  const [dataList, setDataList] = React.useState([]);
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [openFilterStatus, setOpenFilterStatus] = React.useState(false);
  const [search, setSearchValue] = React.useState("");
  const [itemDel, setItemDel] = React.useState("");
  const [perPage, setPerPage] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const [filteredStatus, setFilteredStatus] = React.useState(["pending", "in_progress", "completed"]);
  const statusRef = React.useRef(null);

  const handleToggleStatus = () => {
    setOpenFilterStatus((prevOpen) => !prevOpen);
  }

  const handleCloseStatus = (event) => {
    if (statusRef.current && statusRef.current.contains(event.target)) {
      return
    }
    setOpenFilterStatus(false)
  }

  const handleStatusFilterKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenFilterStatus(false);
    } else if (event.key === "Escape") {
      setOpenFilterStatus(false);
    }
  }

  const handleFilterStatus = (data) => {
    let tmpFilteredStatus = [...filteredStatus]
    if (data !== "selectAll") {
      if (!tmpFilteredStatus.includes(data)) {
        tmpFilteredStatus.push(data)
      } else {
        tmpFilteredStatus = tmpFilteredStatus.filter(status => status !== data)
      }
    } else {
      if (tmpFilteredStatus.length < 3) {
        tmpFilteredStatus = ["pending", "in_progress", "completed"]
      } else {
        tmpFilteredStatus = []
      }
    }
    setFilteredStatus(tmpFilteredStatus)
  }

  const statusBox = (data, isCenter = false) => {
    let fontColor = "#404349"
    let backgroundColor = "#A0A0A0"
    let text = "-"
    if (data === "in_progress" || data === "ระหว่างดำเนินการ") {
      fontColor = "#EFB76D"
      backgroundColor = "rgba(239, 183, 109, 0.1)"
      text = "In Progress"
    } else if (data === "pending" || data === "รออนุมัติ") {
      fontColor = "#F28E2B"
      backgroundColor = "rgba(242, 142, 43, 0.1)"
      text = "Pending"
    } else if (data === "completed" || data === "approved" || data === "เสร็จสิ้น") {
      fontColor = "#5DA196"
      backgroundColor = "rgba(93, 161, 150, 0.1)"
      text = "Completed"
    }

    return (
      <Box sx={{ backgroundColor: backgroundColor ?? "#fff", width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', width: "130px", height: "40px" }}>
        <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={fontColor}>
          {Util.upperFirstWord(text)}
        </Typography>
      </Box>
    )
  }

  const goTo = (route, data) => {
    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }

  let fetchData = () => {
    dispatch(getCalibrationList()).then(resp => {
      let data = resp?.calibration_session ?? []
      setDataList(data)
    })
  }

  const filterStatusSearch = (data) => {
    let dataFilter = JSON.parse(JSON.stringify(data))
    dataFilter = dataFilter.filter(item => filteredStatus.includes(item.status))
    setFilteredDataList(dataFilter)
  }
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  }
  // table data
  const currentData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    return filteredDataList.slice(firstPageIndex, lastPageIndex);
  }, [filteredDataList, currentPage, perPage]);

  const handleTotalPage = () => {
    const List = filteredDataList;
    const totalPage =
      Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage);
    setTotalPage(totalPage);
  };

  const doSearch = (data) => {
    let result = [];
    let dataSearch = JSON.parse(
      JSON.stringify(
        data !== undefined && data !== null ? data : dataList
      )
    );
    if (
      search !== "" &&
      dataSearch !== undefined &&
      dataSearch.length > 0
    ) {
      let resultData = dataSearch.filter((rs) => {
        return Object.keys(rs).some((key) => {
          if (key === "name" || key === "code") {
            return (
              rs[key]
                .toString()
                .toLowerCase()
                .indexOf(search.toString().toLowerCase()) !== -1
            );
          }
        });
      });
      result = resultData;
    } else {
      result = dataSearch;
    }
    filterStatusSearch(result);
  };

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
  };
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(
      (item) => item.type === "page" && item.selected
    );
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1);
  };

  let sortData = (key, direction) => {
    let result = [...filteredDataList]
    result = result.sort(function (b, a) {
      if (key === "approver") {
        let aTmp = a?.calibration_session_role?.approver?.employee?.fullname ? a.calibration_session_role.approver.employee.fullname : ""
        let bTmp = b?.calibration_session_role?.approver?.employee?.fullname ? b.calibration_session_role.approver.employee.fullname : ""
        if (!direction) {
          return aTmp?.toLowerCase()?.localeCompare(bTmp.toLowerCase())
        } else {
          return bTmp.toLowerCase()?.localeCompare(aTmp.toLowerCase())
        }
      } else {
        if (!direction) {
          return a[key].toLowerCase().localeCompare(b[key].toLowerCase())
        } else {
          return b[key].toLowerCase().localeCompare(a[key].toLowerCase())
        }
      }
    })
    setFilteredDataList(result)
  }

  const onScroll = (evt) => {
    if (evt !== undefined && evt !== null) {
      if (openFilterStatus) {
        setOpenFilterStatus(false);
      }
    }
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  const handleClickEdit = (serial) => {
    goTo("/calibration/" + serial)
  }

  // ----------------------------------- useEffect here -----------------------------------
  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    setFilteredDataList(dataList)
  }, [dataList])

  useEffect(() => {
    handleTotalPage()
  }, [currentData])

  useEffect(() => {
    doSearch()
  }, [search, filteredStatus])
  // ----------------------------------- end useEffect -----------------------------------

  const columnsWidth = [
    "calc(8% - 12px)",
    "calc(26% - 12px)",
    "calc(26% - 12px)",
    "calc(26% - 12px)",
    "calc(15% - 12px)",
    "calc(13% - 12px)",
    "50px"
  ]

  return (
    <Box
      onScroll={onScroll}
      sx={{ maxHeight: "100%", overflowY: "auto" }}
    >
      <Helmet>
        <title>Calibration | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.end}>{t("calibration.label.title")}</span>
            </Typography>
          </Grid>
          <Grid container item>
            <Grid item>
              <Typography
                color="#404349"
                fontSize={36}
                fontWeight="600"
              >
                {t("calibration.label.title")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid container item>
              <Box sx={{ width: "100%" }}>
                <Box
                  pb="30px"
                  pt="30px"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    fullWidth
                    placeholder={t("calibration.label.search")}
                    size="small"
                    sx={{
                      background: "#fff",
                      width: "400px",
                      input: { padding: "11px 14px 11px 0px" },
                      ".MuiOutlinedInput-root": { color: "#404349" },
                    }}
                    className="searchTextField-h40"
                    value={search}
                    onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search style={{ color: "#C4C4C4" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>
              {/* table list */}
              <div className={classes.wrapperContent}>
                <Paper className={classes.flexPaper}>
                  <Box px="40px">
                    <Box
                      px="25px"
                      py="19px"
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[0],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.code")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("code", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("code", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[1],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.cycle")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("cycle", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("cycle", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[2],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.name")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("name", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("name", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[3],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.approver")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("approver", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("approver", false)}
                          />
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[4],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.status")}
                        </Typography>
                        <Stack direction="row" spacing={2}>
                          <div>
                            <FilterStatus
                              ref={statusRef}
                              id="composition-button"
                              style={{ cursor: "pointer" }}
                              onClick={handleToggleStatus}
                            />
                            <Popper
                              open={openFilterStatus}
                              anchorEl={statusRef.current}
                              role={undefined}
                              placement="bottom-start"
                              transition
                              disablePortal
                              style={{ zIndex: 2 }}
                            >
                              {({ TransitionProps, placement }) => (
                                <Grow
                                  {...TransitionProps}
                                  style={{
                                    transformOrigin:
                                      placement === "bottom-start"
                                        ? "left top"
                                        : "left bottom",
                                  }}
                                >
                                  <Paper
                                    sx={{ "margin-top": "5px !important" }}
                                  >
                                    <ClickAwayListener
                                      onClickAway={handleCloseStatus}
                                    >
                                      <MenuList
                                        autoFocusItem={openFilterStatus}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleStatusFilterKeyDown}
                                      >
                                        <Box px="16px" py="6px">
                                          <FormGroup>
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  indeterminate={
                                                    filteredStatus.length > 0 && filteredStatus.length < 3
                                                  }
                                                  onChange={(e) =>
                                                    handleFilterStatus("selectAll")
                                                  }
                                                  checked={
                                                    filteredStatus.length === 3
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              }
                                              label={t("competency.selectAll")}
                                            />
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  onChange={(e) =>
                                                    handleFilterStatus("pending")
                                                  }
                                                  checked={filteredStatus.includes("pending")}
                                                />
                                              }
                                              label={t("calibration.label.pending")}
                                            />
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  onChange={(e) =>
                                                    handleFilterStatus("in_progress")
                                                  }
                                                  checked={filteredStatus.includes("in_progress")}
                                                />
                                              }
                                              label={t("calibration.label.inprogress")}
                                            />
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  onChange={(e) =>
                                                    handleFilterStatus("completed")
                                                  }
                                                  checked={filteredStatus.includes("completed")}
                                                />
                                              }
                                              label={t("calibration.label.completed")}
                                            />
                                          </FormGroup>
                                        </Box>
                                      </MenuList>
                                    </ClickAwayListener>
                                  </Paper>
                                </Grow>
                              )}
                            </Popper>
                          </div>
                        </Stack>
                      </Box>
                      {/* <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[5],
                        }}
                        pr="15px"
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "max-content",
                            marginRight: "10px",
                          }}
                        >
                          {t("calibration.label.lastUpdate")}
                        </Typography>
                        <Typography
                          component="span"
                          style={{
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                          }}
                        >
                          <ChevronExpandUp
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("last_updated", true)}
                          />
                          <ChevronExpandDown
                            style={{ cursor: "pointer" }}
                            onClick={(e) => sortData("last_updated", false)}
                          />
                        </Typography>
                      </Box> */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: columnsWidth[6],
                        }}
                      >
                        <Typography
                          fontSize={16}
                          lineHeight="23.96px"
                          color="#A0A0A0"
                          fontWeight="500"
                          sx={{
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {t("calibration.label.action")}
                        </Typography>
                      </Box>
                    </Box>
                    <Divider width="100%" />
                  </Box>
                  {/* table data */}
                  {currentData &&
                    currentData.length > 0 ? (
                    currentData.map((row, index) => (
                      <Box px="40px" key={row.id}>
                        <Box
                          sx={{
                            width: "100%",
                            position: "relative"
                          }}
                        >
                          <Box
                            sx={{
                              height: "96px",
                              background: "#FFF",
                              width: "100%",
                              display: "flex",
                              "align-items": "center",
                            }}
                            px="25px"
                          >
                            <Box sx={{ width: columnsWidth[0] }} pr="15px">
                              <Typography
                                fontSize={16}
                                color="#404349"
                                lineHeight="23.96px"
                                fontWeight="400"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.code}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[1] }} pr="15px">
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="23.92px"
                                sx={{
                                  color: "#404349",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.cycle?.name}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={14}
                                lineHeight="23.92px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#AAAAAA"
                              >
                                {row?.cycle?.start_date ? Util.dateDayFormatAdmin(row?.cycle?.start_date) : "-"} - {row?.cycle?.end_date ? Util.dateDayFormatAdmin(row?.cycle?.end_date) : "-"}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[2] }} pr="15px">
                              <Typography
                                fontWeight="500"
                                fontSize={16}
                                lineHeight="23.92px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#404349"
                              >
                                {row?.name ?? "-"}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={14}
                                lineHeight="23.92px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#AAAAAA"
                              >
                                {Util.dateDayFormatAdmin(row?.start_date) ?? "-"} - {Util.dateDayFormatAdmin(row?.end_date) ?? "-"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: columnsWidth[3],
                              }}
                              pr="15px"
                            >
                              <Typography
                                fontWeight="500"
                                fontSize={16}
                                lineHeight="24px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#404349"
                              >
                                {row?.calibration_session_role?.approver?.employee?.fullname ?? ""}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={12}
                                lineHeight="21px"
                                noWrap
                                sx={{
                                  color: "#A3A3A3",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.calibration_session_role?.approver?.employee?.position ?? ""}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={10}
                                lineHeight="21px"
                                noWrap
                                sx={{
                                  color: "#A3A3A3",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row?.calibration_session_role?.approver?.employee?.organization ?? ""}
                              </Typography>
                            </Box>
                            <Box sx={{ width: columnsWidth[4] }} pr="15px">
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="23.92px"
                                sx={{
                                  color: "#5DA196",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {statusBox(row?.status)}
                              </Typography>
                            </Box>
                            {/* <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: columnsWidth[5],
                              }}
                              pr="15px"
                            >
                              <Typography
                                fontWeight="400"
                                fontSize={16}
                                lineHeight="24px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#404349"
                              >
                                {row?.updated_by}
                              </Typography>
                              <Typography
                                fontWeight="400"
                                fontSize={14}
                                lineHeight="21px"
                                sx={{
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                color="#A3A3A3"
                              >
                                {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                              </Typography>
                            </Box> */}
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                width: columnsWidth[6],
                                justifyContent: "flex-end",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  width: "100px",
                                  "z-index": "1",
                                }}
                              >
                                <Box>
                                  <BootstrapTooltip
                                    title={`Edit`}
                                    placement="top"
                                  >
                                    <EditIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        handleClickEdit(row?.serial ?? null)
                                      }}
                                    />
                                  </BootstrapTooltip>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        <Divider width="100%" />
                      </Box>
                    ))
                  ) : (
                    <Box
                      sx={{
                        pt: "50px",
                        textAlign: "center",
                        pb: "500px",
                      }}
                    >
                      <Nodata />
                      <Typography
                        color="#A0A0A0"
                        fontWeight="500"
                        fontSize={20}
                        lineHeight="30px"
                      >
                        {t("label.noData")}
                      </Typography>
                    </Box>
                  )}
                </Paper>
              </div>
            </Grid>
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs sm md display="flex" alignItems="center">
              <Box mr={1}>
                <Typography variant="s14_fw400">
                  {t("label.showMaxItems")}
                </Typography>
              </Box>
              <Select
                id="pagination"
                variant="outlined"
                defaultValue={10}
                value={perPage}
                onChange={handlePerPageChange}
                displayEmpty
                size="small"
                className="white-bg"
              >
                <MenuItem value={10}>
                  <Typography style={{ fontWeight: "300" }}>10</Typography>
                </MenuItem>
                <MenuItem value={20}>
                  <Typography style={{ fontWeight: "300" }}>20</Typography>
                </MenuItem>
                <MenuItem value={30}>
                  <Typography style={{ fontWeight: "300" }}>30</Typography>
                </MenuItem>
              </Select>
            </Grid>
            <Grid item display="flex" alignItems="center" ml="auto">
              <Typography variant="s14_fw400">
                {t("label.page")} {currentPage} {t("label.of")} {totalPage}
              </Typography>
            </Grid>
            <Grid item ml="auto" display="flex" alignItems="center">
              <CustomPagination
                setCurrentPage={handleSetCurrentPage}
                selected={currentPage}
                count={totalPage}
              ></CustomPagination>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
export default Calibration;
